import reducer from './reducers';
import { stateKey } from 'utils';

const STATE_KEY = stateKey(reducer);

const entities = state => state[STATE_KEY];

export default {
  entities,
};
